import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAuthFormErrors = (errors) => ({
  type: actionTypes.SET_AUTH_FORM_ERRORS,
  payload: errors
})
